import axios from "axios";
import i18n from "i18next";
import { logout } from "../Auth";
// import { translateLanguagesList } from "../../utilities/util";
import { validateResponseObject } from "../../utilities/validateApiResponse";

const mapLangToApi = (lang: string): string => {
  const l = lang.toLowerCase();
  if (l.startsWith("en")) return "en-us";
  if (l.startsWith("pt")) return "pt-br";
  // adicione outros idiomas se precisar
  return "pt-br"; // fallback
};

const ApiHandler = (baseURL: string): any => {
  // const translateFind = translateLanguagesList().find(
  //   (item: any) => item.name === i18n.language,
  // );

  // const translateName =
  //   translateFind !== undefined ? translateFind.name : "pt-br";

  console.log('ApiHandler baseURL:', baseURL);
  const api = axios.create({
    // baseURL: `${baseURL}/${translateName?.toLowerCase()}/api/`,
    baseURL,
    responseType: `json`,
    withCredentials: true, // Importante: permite enviar cookies com as requisições
  });


  api.interceptors.request.use(
    (config: any) => {
      // 1) obtém idioma mapeado
      const lang = mapLangToApi(i18n.language || "pt-br");

      // 2) injeta "/{lang}/api" apenas se ainda não tiver
      if (config.url && !config.url.startsWith(`/${lang}/api/`)) {
        config.url = `/${lang}/api${config.url}`;
      }

      // Sem token manual: os cookies HttpOnly seguem com a requisição.
      return config;
    },
    (error) => Promise.reject(error),
  );

  api.interceptors.response.use(
    (response) => {
      // Se for blob, não tenta processar como JSON
      if (
        response?.config?.responseType === "blob" ||
        response?.headers["content-type"]?.includes(
          "application/octet-stream",
        ) ||
        response?.headers["content-disposition"]?.includes("attachment")
      ) {
        return response; // retorna o blob "cru"
      }

      let returnData: any = validateResponseObject(response);
      return returnData;
    },
    (error) => {
      const status = error?.response?.status;

      if (status === 401) {
        // Ao detectar sessão inválida, limpamos rastros locais e voltamos para /login.
        logout();
      }

      const returnData: any = validateResponseObject(error);
      return Promise.reject(returnData);
    },
  );

  return api;
};

export default ApiHandler;
